document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.featured-collections__slider .swiper').forEach((slider) => {
        const section = slider.closest('.featured-collections__slider');
        
        if (slider.classList.contains('swiper-initialized')) return;

        const swiper = new Swiper(slider, {
            slidesPerView: 2,
            spaceBetween: 16,
            draggable: false,
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
                draggable: true,
            },
            navigation: {
                nextEl: section.querySelector('.swiper-arrow--next'),
                prevEl: section.querySelector('.swiper-arrow--prev'),
            },
            breakpoints: {
                750: { slidesPerView: 2 },
                1200: { slidesPerView: 2.5 }
            }
        });
    });
});